/**
 * Canonical accent palette - 5 families × tones (Terracotta/brown, Teal,
 * Primrose, Pink, Warm grey).
 *
 * ⚠️ Source of truth for the *build-time* path is still
 * src/styles/accent.css (the :root[data-accent="…"] map). This array
 * mirrors those exact hexes so the admin Appearance picker can offer the
 * vetted palette as swatches. If you change a preset, change BOTH here
 * and in accent.css (they intentionally duplicate - accent.css has no JS,
 * this list is for the runtime picker).
 *
 * Team edits: the second-darkest brown (#6B342B) and all three Cool grey
 * tones were removed, and the remaining deep brown (#3F1D17) folded into the
 * Terracotta family so the four browns form one group.
 */

export interface AccentPreset {
  /** data-accent name in accent.css */
  name: string;
  family: string;
  tone: 'Deepest' | 'Deeper' | 'Base' | 'Lifted';
  hex: string;
}

export const ACCENT_PRESETS: AccentPreset[] = [
  // Brown ramp - one family group (deepest → peach), no internal divider.
  // #3F1D17 keeps its legacy data-accent name 'burgundy-base' (so saved prefs
  // still resolve), but now reads as the deepest tone of the Terracotta family.
  { name: 'burgundy-base', family: 'Terracotta', tone: 'Deepest', hex: '#3F1D17' },
  { name: 'terracotta-deeper', family: 'Terracotta', tone: 'Deeper', hex: '#8F4F33' },
  { name: 'terracotta-base', family: 'Terracotta', tone: 'Base', hex: '#C97D58' },
  { name: 'terracotta-lifted', family: 'Terracotta', tone: 'Lifted', hex: '#E2A98A' },

  { name: 'teal-deeper', family: 'Teal', tone: 'Deeper', hex: '#355861' },
  { name: 'teal-base', family: 'Teal', tone: 'Base', hex: '#4F7E8C' },
  { name: 'teal-lifted', family: 'Teal', tone: 'Lifted', hex: '#7BA5B2' },

  { name: 'primrose-deeper', family: 'Primrose', tone: 'Deeper', hex: '#C9A521' },
  { name: 'primrose-base', family: 'Primrose', tone: 'Base', hex: '#F4D03F' },
  { name: 'primrose-lifted', family: 'Primrose', tone: 'Lifted', hex: '#F8DE73' },

  { name: 'pink-deeper', family: 'Pink', tone: 'Deeper', hex: '#D87689' },
  { name: 'pink-base', family: 'Pink', tone: 'Base', hex: '#F4A7B9' },
  { name: 'pink-lifted', family: 'Pink', tone: 'Lifted', hex: '#FAC8D2' },

  { name: 'warm-grey-deeper', family: 'Warm grey', tone: 'Deeper', hex: '#423D37' },
  { name: 'warm-grey-base', family: 'Warm grey', tone: 'Base', hex: '#8A8276' },
  { name: 'warm-grey-lifted', family: 'Warm grey', tone: 'Lifted', hex: '#C8BFAF' },
];
